import {
  globalSearchResponseSchema,
  recentSearchRecordResponseSchema,
  type GlobalSearchResponse,
  type SearchEntityType,
} from '@erp/shared';
import {
  useMutation,
  useQuery,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import { apiFetch, type ApiError } from '@/lib/api-client';

export function useGlobalSearch(input: {
  query: string;
  entityTypes?: readonly SearchEntityType[] | undefined;
  enabled: boolean;
}): UseQueryResult<GlobalSearchResponse, ApiError> {
  return useQuery({
    queryKey: ['global-search', input.query, input.entityTypes ?? []],
    queryFn: ({ signal }) => {
      const params = new URLSearchParams({ q: input.query, page: '1', pageSize: '30' });
      if (input.entityTypes !== undefined) params.set('entityTypes', input.entityTypes.join(','));
      return apiFetch(`/api/v1/search?${params.toString()}`, globalSearchResponseSchema, {
        signal,
      });
    },
    enabled: input.enabled,
    staleTime: input.query.length === 0 ? 15_000 : 5_000,
  });
}

export function useRecordRecentSearch(): UseMutationResult<{ recorded: true }, ApiError, string> {
  return useMutation({
    mutationFn: (searchIndexId) =>
      apiFetch('/api/v1/search/recent', recentSearchRecordResponseSchema, {
        method: 'POST',
        body: { searchIndexId },
      }),
  });
}
